
let language = {
    STANDARD_CANCEL_PAYMENT_FAIL_TITLE: "Payment Failure !",
    STANDARD_CANCEL_PAYMENT_FAIL_INFO_TIP: "We are sorry to inform you that your order was not paid successfully",
    
    STANDARD_CANCEL_BACK_ORDER_BTN: "Back to My Order",
    STANDARD_CANCEL_CONTINUE_SHOPPING_BTN: "Continue Shopping",
};

export { language }